import React from "react";

import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { avatar5, logo } from "../../Images";

const getClassName = ({ isActive }) => {
  return isActive ? "nav-link active" : "nav-link";
};

const Sidebar = () => {
  const darkMode = useSelector((state) => state.theme.darkMode);

  let { userInfo } = useSelector((state) => state.auth);
  console.log("🚀 ~ userInfo:", userInfo)

  if (!userInfo) {
    userInfo = {};
  }

  return (
    <aside className={`main-sidebar elevation-4 ${darkMode ? "sidebar-dark-primary" : "sidebar-light-navy"}`}>
      {/* Brand Logo */}
      <a href="#" className="brand-link">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            margin: "0.2rem 0.2rem 0.2rem 0.2rem",
          }}
        >
          <img
            src={logo}
            alt="AdminLTE Logo"
            className="brand-image img-circle elevation-3"
            style={{
              opacity: ".8",
              background: "white",
              padding: 2,
            }}
          />
          <span className="brand-text font-weight-light" style={{ fontSize: "1.1rem" }}>
            <strong style={{ color: "orange", fontWeight: 700 }}>PMC</strong> MODENA
          </span>
        </div>
      </a>
      {/* Sidebar */}
      <div className="sidebar">
        {/* Sidebar user panel (optional) */}
        <div className="user-panel mt-3 pb-3 mb-3 d-flex">
          <div className="image">
            <img
              src={userInfo.image_name ? userInfo.image_name : avatar5}
              className="img-circle elevation-2"
              alt="User Image"
              style={{ height: 40, width: 40 }}
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = avatar5;
              }}
            />
          </div>
          <div className="info">
            <a href="#" className="d-block">
              {userInfo.fullname}
            </a>
          </div>
        </div>
        {/* Sidebar Menu */}
        <nav className="mt-2">
          <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu">
            {userInfo?.access?.dashboard?.can_view && (
              <li className="nav-item" style={{ marginBottom: "0.1rem" }}>
                <NavLink to="/dashboard" className={getClassName}>
                  <i className="nav-icon fas fa-th" />
                  <p>Dashboard</p>
                </NavLink>
              </li>
            )}

            {userInfo?.access?.approvals?.can_view && (
              <li className="nav-item" style={{ marginBottom: "0.1rem" }}>
                <NavLink to="/approvals" className={getClassName}>
                  <i className="nav-icon fas fa-clipboard" />
                  <p>Approvals</p>
                </NavLink>
              </li>
            )}

            {userInfo?.access?.master?.can_view && (
              <li className="nav-item" style={{ marginBottom: "0.5rem" }}>
                <a href="#" className="nav-link">
                  <i className="nav-icon fas fa-hdd" />
                  <p>
                    Master
                    <i className="right fas fa-angle-left"></i>
                  </p>
                </a>
                <ul className="nav nav-treeview">
                  {userInfo?.access?.master_segment?.can_view && (
                    <li className="nav-item">
                      <NavLink to="/segment" className={getClassName}>
                        <i className="far fa-circle nav-icon" />
                        <p>Segments</p>
                      </NavLink>
                    </li>
                  )}
                  {userInfo?.access?.master_category?.can_view && (
                    <li className="nav-item">
                      <NavLink to="/category" className={getClassName}>
                        <i className="far fa-circle nav-icon" />
                        <p>Categories</p>
                      </NavLink>
                    </li>
                  )}
                  {userInfo?.access?.master_subcategory?.can_view && (
                    <li className="nav-item">
                      <NavLink to="/subcategory" className={getClassName}>
                        <i className="far fa-circle nav-icon" />
                        <p>Subcategories</p>
                      </NavLink>
                    </li>
                  )}{" "}
                  {userInfo?.access?.master_subsubcategory?.can_view && (
                    <li className="nav-item">
                      <NavLink to="/subsubcategory" className={getClassName}>
                        <i className="far fa-circle nav-icon" />
                        <p>Sub-Subcategories</p>
                      </NavLink>
                    </li>
                  )}
                  {userInfo?.access?.master_brand?.can_view && (
                    <li className="nav-item">
                      <NavLink to="/brand" className={getClassName}>
                        <i className="far fa-circle nav-icon" />
                        <p>Brands</p>
                      </NavLink>
                    </li>
                  )}
                  {userInfo?.access?.master_series?.can_view && (
                    <li className="nav-item">
                      <NavLink to="/series" className={getClassName}>
                        <i className="far fa-circle nav-icon" />
                        <p>Series</p>
                      </NavLink>
                    </li>
                  )}
                  {userInfo?.access?.master_series?.can_view && (
                    <li className="nav-item">
                      <NavLink to="/iot-series" className={getClassName}>
                        <i className="far fa-circle nav-icon" />
                        <p>IoT Series</p>
                      </NavLink>
                    </li>
                  )}
                  {userInfo?.access?.master_language?.can_view && (
                    <li className="nav-item">
                      <NavLink to="/language" className={getClassName}>
                        <i className="far fa-circle nav-icon" />
                        <p>Languages</p>
                      </NavLink>
                    </li>
                  )}
                  {userInfo?.access?.master_store_onlune?.can_view && (
                    <li className="nav-item">
                      <NavLink to="/store-online" className={getClassName}>
                        <i className="far fa-circle nav-icon" />
                        <p>Online Stores</p>
                      </NavLink>
                    </li>
                  )}
                  {userInfo?.access?.master_color?.can_view && (
                    <li className="nav-item">
                      <NavLink to="/color" className={getClassName}>
                        <i className="far fa-circle nav-icon" />
                        <p>Colors</p>
                      </NavLink>
                    </li>
                  )}
                  {userInfo?.access?.master_tag?.can_view && (
                    <li className="nav-item">
                      <NavLink to="/tag" className={getClassName}>
                        <i className="far fa-circle nav-icon" />
                        <p>Tags</p>
                      </NavLink>
                    </li>
                  )}
                  {userInfo?.access?.master_country?.can_view && (
                    <li className="nav-item">
                      <NavLink to="/country" className={getClassName}>
                        <i className="far fa-circle nav-icon" />
                        <p>Countries</p>
                      </NavLink>
                    </li>
                  )}
                  {(userInfo?.access?.master_certificate?.can_view || userInfo?.access?.master_certification?.can_view) && (
                    <li className="nav-item">
                      <NavLink to="/certificate" className={getClassName}>
                        <i className="far fa-circle nav-icon" />
                        <p>Certificates</p>
                      </NavLink>
                    </li>
                  )}
                  {userInfo?.access?.master_electrical_rating?.can_view && (
                    <li className="nav-item">
                      <NavLink to="/electrical-rating" className={getClassName}>
                        <i className="far fa-circle nav-icon" />
                        <p>Electrical Ratings</p>
                      </NavLink>
                    </li>
                  )}
                  {userInfo?.access?.master_assembly?.can_view && (
                    <li className="nav-item">
                      <NavLink to="/assembly" className={getClassName}>
                        <i className="far fa-circle nav-icon" />
                        <p>Assemblies</p>
                      </NavLink>
                    </li>
                  )}
                  {userInfo?.access?.master_part_change?.can_view && (
                    <li className="nav-item">
                      <NavLink to="/part-change-location" className={getClassName}>
                        <i className="far fa-circle nav-icon" />
                        <p>Part Change Locations</p>
                      </NavLink>
                    </li>
                  )}
                  {userInfo?.access?.master_feature?.can_view && (
                    <li className="nav-item">
                      <NavLink to="/feature" className={getClassName}>
                        <i className="far fa-circle nav-icon" />
                        <p>Features</p>
                      </NavLink>
                    </li>
                  )}
                  {/* <li className="nav-item">
                    <NavLink to="/feature-type" className={getClassName}>
                      <i className="far fa-circle nav-icon" />
                      <p>Feature Type</p>
                    </NavLink>
                  </li> */}
                </ul>
              </li>
            )}

            {userInfo?.access?.sku_config?.can_view && (
              <li className="nav-item" style={{ marginBottom: "0.5rem" }}>
                <a href="#" className="nav-link">
                  <i className="nav-icon fas fa-cog" />
                  <p>
                    SKU Config
                    <i className="right fas fa-angle-left"></i>
                  </p>
                </a>
                <ul className="nav nav-treeview">
                  <li className="nav-item">
                    <NavLink to="/sku" className={getClassName}>
                      <i className="nav-icon far fa-circle" />
                      <p>SKU Header</p>
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}

            {userInfo?.access?.app_list?.can_view && (
              <li className="nav-item" style={{ marginBottom: "0.5rem" }}>
                <a href="#" className="nav-link">
                  <i className="nav-icon fas fa-mobile" />
                  <p>
                    App Config
                    <i className="right fas fa-angle-left"></i>
                  </p>
                </a>
                <ul className="nav nav-treeview">
                  <li className="nav-item">
                    <NavLink to="/app-list" className={getClassName}>
                      <i className="nav-icon far fa-circle" />
                      <p>App List</p>
                    </NavLink>
                  </li>
                  {userInfo?.access?.app_list?.can_view && (
                    <li className="nav-item">
                      <NavLink to="/image-function" className={getClassName}>
                        <i className="nav-icon far fa-circle" />
                        <p>Image Function</p>
                      </NavLink>
                    </li>
                  )}
                  {userInfo?.access?.app_list?.can_view && (
                    <li className="nav-item">
                      <NavLink to="/video-function" className={getClassName}>
                        <i className="nav-icon far fa-circle" />
                        <p>Video Function</p>
                      </NavLink>
                    </li>
                  )}
                </ul>
              </li>
            )}

            {userInfo?.access?.product?.can_view && (
              <li className="nav-item" style={{ marginBottom: "0.5rem" }}>
                <a href="#" className="nav-link">
                  <i className="nav-icon fas fa-briefcase" />
                  <p>
                    Product
                    <i className="right fas fa-angle-left"></i>
                  </p>
                </a>
                <ul className="nav nav-treeview">
                  {userInfo?.access?.product_color?.can_view && (
                    <li className="nav-item">
                      <NavLink to="/product-color" className={getClassName}>
                        <i className="nav-icon far fa-circle" />
                        <p>Product Color</p>
                      </NavLink>
                    </li>
                  )}
                  {userInfo?.access?.product_tag?.can_view && (
                    <li className="nav-item">
                      <NavLink to="/product-tag" className={getClassName}>
                        <i className="nav-icon far fa-circle" />
                        <p>Product Tag</p>
                      </NavLink>
                    </li>
                  )}
                  {userInfo?.access?.master_product?.can_view && (
                    <li className="nav-item">
                      <NavLink to="/product" className={getClassName}>
                        <i className="nav-icon far fa-circle" />
                        <p>Master Product</p>
                      </NavLink>
                    </li>
                  )}
                  {userInfo?.access?.master_product_view?.can_view && (
                    <li className="nav-item">
                      <NavLink to="/product-view" className={getClassName}>
                        <i className="nav-icon far fa-circle" />
                        <p>Master Product View</p>
                      </NavLink>
                    </li>
                  )}
                </ul>
              </li>
            )}

            {userInfo?.access?.competitor?.can_view && (
              <li className="nav-item" style={{ marginBottom: "0.5rem" }}>
                <a href="#" className="nav-link">
                  <i className="nav-icon fas fa-briefcase" />
                  <p>
                    Competitor
                    <i className="right fas fa-angle-left"></i>
                  </p>
                </a>
                <ul className="nav nav-treeview">
                  {userInfo?.access?.competitor_brand?.can_view && (
                    <li className="nav-item">
                      <NavLink to="/competitor-brand" className={getClassName}>
                        <i className="nav-icon far fa-circle" />
                        <p>Brand</p>
                      </NavLink>
                    </li>
                  )}
                  {userInfo?.access?.competitor_product?.can_view && (
                    <li className="nav-item">
                      <NavLink to="/competitor-product" className={getClassName}>
                        <i className="nav-icon far fa-circle" />
                        <p>Product</p>
                      </NavLink>
                    </li>
                  )}
                  {userInfo?.access?.competitor_mapping_product?.can_view && (
                    <li className="nav-item">
                      <NavLink to="/competitor-mapping" className={getClassName}>
                        <i className="nav-icon far fa-circle" />
                        <p>Mapping Product</p>
                      </NavLink>
                    </li>
                  )}
                </ul>
              </li>
            )}

            {userInfo?.access?.logs?.can_view && (
              <li className="nav-item" style={{ marginBottom: "0.5rem" }}>
                <NavLink to="/logs" className={getClassName}>
                  <i className="nav-icon fa fa-database" />
                  <p>Sync & Logs</p>
                </NavLink>
              </li>
            )}

            {/* {userInfo?.access?.master_product?.can_view && (
              <li className="nav-item" style={{ marginBottom: "0.5rem" }}>
                <a href="#" className="nav-link">
                  <i className="nav-icon fas fa-briefcase" />
                  <p>
                    Master Reports
                    <i className="right fas fa-angle-left"></i>
                  </p>
                </a>
                <ul className="nav nav-treeview">
                  {userInfo?.access?.master_product?.can_view && (
                    <li className="nav-item">
                      <NavLink to="/master-reports" className={getClassName}>
                        <i className="nav-icon far fa-circle" />
                        <p>Master Report Builder</p>
                      </NavLink>
                    </li>
                  )}
                  {userInfo?.access?.master_product?.can_view && (
                    <li className="nav-item">
                      <NavLink to="/master-export-data" className={getClassName}>
                        <i className="nav-icon far fa-circle" />
                        <p>Form Export Data</p>
                      </NavLink>
                    </li>
                  )}
                  {userInfo?.access?.master_product?.can_view && (
                    <li className="nav-item">
                      <NavLink to="/exported-data" className={getClassName}>
                        <i className="nav-icon far fa-circle" />
                        <p>Schedule Export Data</p>
                      </NavLink>
                    </li>
                  )}
                  {userInfo?.access?.master_product?.can_view && (
                    <li className="nav-item">
                      <NavLink to="/history-exported-data" className={getClassName}>
                        <i className="nav-icon far fa-circle" />
                        <p>History Export Data</p>
                      </NavLink>
                    </li>
                  )}
                </ul>
              </li>
            )} */}

            {(userInfo.role_id == 1 || userInfo.role_id == "63108e7c6d2138fe3c537d43" || userInfo.role_id == "6316dbe3fd540aacb1859090") && (
              <>
                <li className="nav-header">Admin Menu</li>
                <li className="nav-item" style={{ marginBottom: "0.5rem" }}>
                  <NavLink to="/user" className={getClassName}>
                    <i className="nav-icon fas fa-user-tag" />
                    <p>Users</p>
                  </NavLink>
                </li>
                <li className="nav-item" style={{ marginBottom: "0.5rem" }}>
                  <NavLink to="/role" className={getClassName}>
                    <i className="nav-icon fas fa-lock" />
                    <p>Role User</p>
                  </NavLink>
                </li>
              </>
            )}
          </ul>
        </nav>
      </div>
      {/* /.sidebar */}
    </aside>
  );
};

export default Sidebar;
